import request from '@/utils/request'

let School_bank_regApi = {

  /*学校银行信息登记列表*/
  list(data) {
    return request._post('/shop/plus.school_bank_reg.Index/index', data);
},
/*添加学校银行信息登记*/
add(data) {
    return request._post('/shop/plus.school_bank_reg.Index/add', data);
},
/*修改学校银行信息登记*/
edit(data) {
    return request._post('/shop/plus.school_bank_reg.Index/edit', data);
},
/*删除学校银行信息登记*/
del(data) {
    return request._post('/shop/plus.school_bank_reg.Index/del', data);
},
/*学校银行信息登记详情*/
detail(data) {
  return request._post('/shop/plus.school_bank_reg.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.school_bank_reg.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.school_bank_reg.Setting/getSetting', data, errorback);
    },
}
export default School_bank_regApi;



// WEBPACK FOOTER //
// ./src/api/school_bank_reg.js